const actions = {
  AUTH_CHANGE_REMEMBER: "AUTH_CHANGE_REMEMBER",
  LOGIN_CHANGE_VALUE: "LOGIN_CHANGE_VALUE",
  LOGIN_CHANGE_ITEM: "LOGIN_CHANGE_ITEM",
  SIGN_IN: "SIGN_IN",
  SIGN_OUT: "SIGN_OUT",
  REGISTRATION_ACCEPT: "REGISTRATION_ACCEPT",
  REGISTRATION_CHANGE_ITEM: "REGISTRATION_CHANGE_ITEM",
  REGISTRATION_CHANGE_VALUE: "REGISTRATION_CHANGE_VALUE",
  AUTH_IS_LOADING: "AUTH_IS_LOADING",
  AUTH_HAS_ERROR: "AUTH_HAS_ERROR",
  LOAD_USER: "LOAD_USER",
  PASSWORD_CHANGE_SUCCESS: "PASSWORD_CHANGE_SUCCESS",
  PASSWORD_CHANGE_FAIL: "PASSWORD_CHANGE_FAIL",
  EMAIL_SEND_SUCCESS: "EMAIL_SEND_SUCCESS",
  EMAIL_SEND_FAIL: "EMAIL_SEND_FAIL"
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/constants/auth/index.js